import {
  Dialog,
  DialogTitle as DialogTitleMUI,
  DialogContent as DialogContentMUI,
  Typography,
  Box,
  styled,
} from '@mui/material';

export const ContainerDialog = styled(Dialog)`
  flex: 1;
`;

export const ContainerIcon = styled(Box)`
  width: 411.8px;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
`;

export const DialogTitle = styled(DialogTitleMUI)`
  font-weight: 600;
  padding: 0;
  margin-bottom: 10px;
`;

export const DialogContent = styled(DialogContentMUI)`
  padding: 0;
  margin: 0;
`;

export const DialogSubtitle = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0;
  margin: 0;

  color: ${({ theme }) => theme.palette.grey[200]};

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DialogFooter = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: end;
  height: 32px;
  margin-top: 15px;
`;
